import { portal } from "@talentpair/portal";
import { ResponseError } from "@talentpair/api";

export function handleThrottle(res: ResponseError<{ detail?: string }> | Error): boolean {
  if (res instanceof ResponseError && res?.status === 429) {
    const seconds = parseInt(res.data?.detail?.match(/(\d+)/g)?.[0] || "100", 10);
    portal.snackbar({
      type: "warning",
      message: `You've reached your message limit. Please retry ${
        seconds > 60 ? "later" : "in a minute"
      }.`,
    });
    return true;
  }
  return false;
}
